import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { Button, FormField } from '@campaignhub/suit-theme'

import { useSetState } from '@campaignhub/react-hooks'

const defaultState = {
  aiPrompt: '',
  selectedPrompt: '',
  assetName: '',
}

const AiGenerationTab = (props) => {
  const {
    assetPrompts, generating, promptFileType, promptsLoading, callbacks,
    asNewAsset, defaultName = '',
  } = props

  const { generate } = callbacks

  const { creating } = useSelector(reduxState => reduxState.prompts)

  const [state, setState] = useSetState({ ...defaultState, assetName: defaultName || '' })
  const { aiPrompt, selectedPrompt, assetName } = state

  const handleGenerate = async () => {
    const selectedPromptData = assetPrompts.find(prompt => prompt.id === selectedPrompt)
    const { promptValue: selectedPromptValue } = selectedPromptData || {}

    const staticPromptValues = assetPrompts
      .filter(prompt => prompt.fileType?.includes(promptFileType) && prompt.static)
      .map(prompt => prompt.promptValue)

    const customPrompt = aiPrompt.trim()
    const finalPrompt = [selectedPromptValue, customPrompt, ...staticPromptValues].filter(Boolean).join(' ')

    const { success } = await generate({
      prompt: finalPrompt,
      promptKey: selectedPromptData?.tag,
      customPrompt,
      // CH-4304: the operator names the new asset — prefilled with the base's name.
      ...(asNewAsset ? { outputName: assetName } : {}),
    })

    if (success){
      setState({ selectedPrompt: '', aiPrompt: '' })
    }
  }

  return (
    <>
      {asNewAsset && (
        <FormField direction="column" label="Asset name" marginTop="large" value={assetName}>
          <input
            type="text"
            value={assetName}
            onChange={e => setState({ assetName: e.target.value })}
            placeholder="Name for the new asset..."
          />
        </FormField>
      )}
      <FormField direction="column" label="Prompts" marginTop="large" value={selectedPrompt}>
        <select
          value={selectedPrompt}
          disabled={promptsLoading}
          onChange={e => setState({ selectedPrompt: e.target.value })}
        >
          <option value="">{promptsLoading ? 'Loading prompts...' : 'Select a prompt...'}</option>
          {assetPrompts
            .filter(prompt => prompt.fileType?.includes(promptFileType) && !prompt.static)
            .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
            .map(prompt => (
              <option key={prompt.id} value={prompt.id}>{prompt.tag}</option>
            ))}
        </select>
      </FormField>

      <FormField direction="column" marginTop="large">
        <textarea
          name="aiPrompt"
          placeholder="Describe the version you want to generate..."
          value={aiPrompt}
          onChange={e => setState({ aiPrompt: e.target.value })}
          style={{ height: 120, resize: 'none', width: '100%' }}
        />
      </FormField>

      <Button
        buttonStyle="primaryCreate"
        disabled={creating || generating || (!selectedPrompt && !aiPrompt.trim())}
        loading={creating || generating}
        marginTop="large"
        onClick={handleGenerate}
        size="medium"
      >
        {generating ? 'Generating...' : 'Generate'}
      </Button>
    </>
  )
}

AiGenerationTab.propTypes = {
  assetPrompts: PropTypes.array,
  asNewAsset: PropTypes.bool,
  callbacks: PropTypes.object.isRequired,
  defaultName: PropTypes.string,
  generating: PropTypes.bool,
  promptFileType: PropTypes.number,
  promptsLoading: PropTypes.bool,
}

export default AiGenerationTab
